import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

function nestedView() {
  return { render: (h) => h('router-view') }
}

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue'), meta: { title: '登录' } },
  {
    path: '/',
    component: () => import('@/layout/AdminLayout.vue'),
    redirect: '/dashboard',
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '经营总览', icon: 'el-icon-data-analysis' },
      },
      {
        path: 'catalog/categories',
        component: () => import('@/views/Categories.vue'),
        meta: { title: '分类管理', icon: 'el-icon-collection-tag' },
      },
      {
        path: 'catalog/tools',
        component: () => import('@/views/Tools.vue'),
        meta: { title: 'AI 工具管理', icon: 'el-icon-s-cooperation' },
      },
      {
        path: 'catalog',
        component: nestedView(),
        redirect: '/catalog/templates',
        meta: { title: '内容运营', icon: 'el-icon-picture-outline' },
        children: [
          {
            path: 'models',
            component: () => import('@/views/Models.vue'),
            meta: { title: '生图模型', icon: 'el-icon-cpu' },
          },
          {
            path: 'prompts',
            component: () => import('@/views/Prompts.vue'),
            meta: { title: '提示词', icon: 'el-icon-edit-outline' },
          },
          {
            path: 'templates',
            component: () => import('@/views/Templates.vue'),
            meta: { title: '模板管理', icon: 'el-icon-files' },
          },
          {
            path: 'banners',
            component: () => import('@/views/Banners.vue'),
            meta: { title: '运营位', icon: 'el-icon-picture' },
          },
        ],
      },
      {
        path: 'customers',
        component: () => import('@/views/Customers.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' },
      },
      {
        path: 'tasks',
        component: () => import('@/views/Tasks.vue'),
        meta: { title: '生成任务', icon: 'el-icon-s-order' },
      },
      {
        path: 'works',
        component: () => import('@/views/Works.vue'),
        meta: { title: '作品管理', icon: 'el-icon-picture-outline-round' },
      },
      {
        path: 'commerce',
        component: nestedView(),
        redirect: '/commerce/products',
        meta: { title: '商品与支付', icon: 'el-icon-goods' },
        children: [
          {
            path: 'products',
            component: () => import('@/views/Products.vue'),
            meta: { title: '商品套餐', icon: 'el-icon-present' },
          },
          {
            path: 'orders',
            component: () => import('@/views/Orders.vue'),
            meta: { title: '支付记录', icon: 'el-icon-tickets' },
          },
          {
            path: 'recharge-gift',
            component: () => import('@/views/RechargeGift.vue'),
            meta: { title: '新用户赠送', icon: 'el-icon-present', platform: true },
          },
        ],
      },
    ],
  },
  { path: '*', redirect: '/dashboard' },
]

function canAccess(to) {
  const role = store.state.user && store.state.user.role
  if (to.matched.some((v) => v.meta.platform) && role !== 'PLATFORM_ADMIN') return false
  if (
    to.matched.some((v) => v.meta.manager) &&
    role !== 'PLATFORM_ADMIN' &&
    role !== 'STORE_MANAGER'
  ) {
    return false
  }
  return true
}

const router = new Router({ mode: 'history', base: process.env.BASE_URL, routes })
router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title || '运营中心'} · Photo`
  const needAuth = to.matched.some((v) => v.meta.auth)
  if (needAuth) {
    if (!store.state.token) return next('/login')
    const ok = await store.dispatch('bootstrap')
    if (!ok) return next('/login')
    if (!canAccess(to)) return next('/dashboard')
    return next()
  }
  if (to.path === '/login' && store.state.token) {
    const ok = await store.dispatch('bootstrap')
    if (ok) return next('/dashboard')
  }
  next()
})

export default router
